import moment from "moment";
import { connect } from "react-redux";
import { createSelector } from "reselect";

import {
  openEvent,
  rescheduleEvent,
  rescheduleEventExplicit,
} from "../../../../redux/calendar";
import { toggleDeleteModal, toggleEditModal } from "../../../../redux/modals";
import { open as togglePrintWorkOrderModal } from "../../../../redux/modals/printWorkOrderModal";
import { showEstimatedQuantitiesSelector } from "../../../../redux/settings";
import JobEvent from "./JobEvent";

const colorMode = (state) => state.settings.color;

const colors = createSelector(
  colorMode,
  (state) => state.dropdowns,
  (colorMode, { jobStatuses, jobTypes, offices }) => {
    switch (colorMode) {
      case "jobStatus":
        return jobStatuses;
      case "office":
        return offices;
      default:
        return jobTypes;
    }
  }
);

const getEvent = (state, { eventId }) =>
  state.events.events.find((e) => e.id === eventId);

const makeGetEvent = () =>
  createSelector(getEvent, colorMode, colors, (event, colorMode, colors) => {
    if (!event.job) {
      return event;
    }

    let color = null;
    switch (colorMode) {
      case "jobType":
        const jobType = colors.find(
          (jobType) => jobType.name === event.job.jobType
        );
        color = jobType ? jobType.color : null;
        break;
      case "office":
        const office = colors.find(
          (office) => event.job.office && office.id === event.job.office.id
        );
        color = office ? office.color : null;
        break;
      case "salesperson":
        const salesperson = event.job.salesperson;
        color = salesperson ? salesperson.calendarColor : null;
        break;
      default:
        const jobStatus = colors.find(
          (jobStatus) => jobStatus.value === event.job.status
        );
        color = jobStatus ? jobStatus.color : null;
        break;
    }
    return { ...event, color };
  });

const makeMapStateToProps = () => {
  const getEvent = makeGetEvent();
  return (state, props) => ({
    detailEnabled: state.settings.detailEnabled,
    entity: state.settings.entity,
    schedulerView: state.settings.schedulerView,
    event: getEvent(state, props),
    financialEnabled: state.settings.financialEnabled,
    hasCalendarEventDelete:
      state.tokenInfo.scope.indexOf("calendarEvents:delete") > -1,
    hasCalendarEventUpdate:
      state.tokenInfo.scope.indexOf("calendarEvents:update") > -1,
    locationEnabled: state.settings.locationEnabled,
    materialEnabled: state.settings.materialEnabled,
    showEstimatedQuantities: showEstimatedQuantitiesSelector(state),
    crew: getEvent(state, props).crew,
    date: getEvent(state, props).endDate,
    currentDate: state.calendar.date || moment(),
    activeEquipment: state.calendar ? state.calendar.activeEquipment : null,
    mode: state.calendar ? state.calendar.mode : "week",
  });
};

const mapDispatchToProps = (dispatch, { eventId }) => ({
  onClick: () => dispatch(rescheduleEvent(eventId)),
  onDeleteEventClick: () => dispatch(toggleDeleteModal(eventId)),
  onEditEventClick: () => dispatch(toggleEditModal(eventId)),
  onOpenClick: () => dispatch(openEvent(eventId)),
  onPrintWorkOrder: (event) =>
    dispatch(
      togglePrintWorkOrderModal({ eventId: event.eventId, date: event.date })
    ),
  onRescheduleRes: (eventId, date, crew, mode) =>
    dispatch(rescheduleEventExplicit(eventId, date, crew, mode)),
});

const mergeProps = (
  {
    event,
    currentDate,
    hasCalendarEventDelete,
    hasCalendarEventUpdate,
    ...stateProps
  },
  {
    onClick,
    onDeleteEventClick,
    onEditEventClick,
    onPrintWorkOrder,
    ...dispatchProps
  },
  ownProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  event,
  onClick: hasCalendarEventUpdate ? onClick : null,
  onDeleteEventClick: hasCalendarEventDelete ? onDeleteEventClick : null,
  onEditEventClick: hasCalendarEventUpdate ? onEditEventClick : null,
  onPrintWorkOrder: () =>
    onPrintWorkOrder({
      eventId: event.id,
      date: moment(currentDate || moment()).format("YYYY-MM-DD"),
    }),
});

export default connect(
  makeMapStateToProps,
  mapDispatchToProps,
  mergeProps
)(JobEvent);
